import { render, staticRenderFns } from "./trionicDetail.vue?vue&type=template&id=ab972500&scoped=true"
import script from "./trionicDetail.vue?vue&type=script&lang=js"
export * from "./trionicDetail.vue?vue&type=script&lang=js"
import style0 from "./trionicDetail.vue?vue&type=style&index=0&id=ab972500&prod&lang=scss&scoped=true"
import style1 from "./trionicDetail.vue?vue&type=style&index=1&id=ab972500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab972500",
  null
  
)

export default component.exports